import React from 'react';
import {Provider} from 'react-redux';
import {PersistGate} from 'redux-persist/lib/integration/react';
import {Route, Switch} from 'react-router-dom';
import HTML5Backend from 'react-dnd-html5-backend';
import {DragDropContext} from 'react-dnd';
import {addLocaleData, IntlProvider} from 'react-intl';
import en from 'react-intl/locale-data/en';
import {enUSmessage} from '../i18n/en-US.js';

import configureStore from './Store.jsx';
import Embed from './Embed.jsx';
import Main from './Main.jsx';
import LoginPage from 'pages/Login/LoginPage';
import UserContext from 'hoc/UserContext';

import * as ResourceActions from 'resources/actions';
import * as ResourceApi from 'api/resources';
import {filterOptionsFactory, sortOptionsFactory} from 'viewOptions/factories';

// Setup our Redux store
const {store, persistor} = configureStore();

// Fetch some resources
const emptySorts = sortOptionsFactory();
const emptyFilters = filterOptionsFactory();
const resourceTypes = [
  ResourceApi.Types.Filter,
  ResourceApi.Types.Site,
  ResourceApi.Types.Group,
  ResourceApi.Types.Category,
];

for (const type of resourceTypes) {
  store.dispatch(ResourceActions.getAllResourcesAction(type, emptySorts, emptyFilters));
}

// Add in the proper locale data file for the given
// language for react-intl
addLocaleData([...en]); // TODO: Make this dynamic

const MainWithUserContext = UserContext(Main);

class App extends React.Component {
  render() {
    return (
      <div>
        <IntlProvider locale="en" messages={enUSmessage} onError={() => {}} >
          <PersistGate persistor={persistor}>
            <Provider store={store}>
              <Switch>
                <Route path="/login" component={LoginPage}  />
                <Route path='/embed' component={Embed} />
                <Route path='/' component={MainWithUserContext} />
              </Switch>
            </Provider>
          </PersistGate>
        </IntlProvider>
      </div>
    );
  }
}

export default DragDropContext(HTML5Backend)(App);



// WEBPACK FOOTER //
// ./public/pages/App.jsx